<h2 mat-dialog-title>Select Sort</h2>
<mat-dialog-content style="min-height: 245px; padding-top: 10px;">
    <div *ngFor="let sort of sorts$ | async; let i = index">
        <mat-form-field>
            <mat-label >
                <span *ngIf="i===0">Sort By</span>
                <span *ngIf="i>0">Then By</span>
            </mat-label>
            <mat-select [(value)]="sort.fieldId">
                <mat-option *ngFor="let field of sortFields" [value]="field[0]">{{field[1]}}</mat-option>
                <ng-container *ngIf="(parents$ | async) as parents">
                    <ng-container *ngIf="(childrenMap$ | async) as childrenMap">
                      <mat-optgroup *ngFor="let parent of parents"
                        [label]="parent.displayTitle">
                        <mat-option *ngFor="let child of childrenMap.get(parent.fieldId)" [value]="child.fieldId">
                          {{child.displayTitle}}
                        </mat-option>
                      </mat-optgroup>
                    </ng-container>
                  </ng-container>
            </mat-select>
        </mat-form-field>
        <mat-form-field>
            <mat-label>Order</mat-label>
            <mat-select [(value)]="sort.direction">
                <mat-option value="ASC">Ascending</mat-option>
                <mat-option value="DESC">Descending</mat-option>
            </mat-select>
        </mat-form-field>
    </div>
</mat-dialog-content>
<mat-dialog-actions style="place-content: stretch space-between; align-items: stretch; flex-direction: row; box-sizing: border-box; display: flex;">
    <div>
        <button mat-button color="primary" (click)="addSortLevel()"><i class="fa-duotone fa-solid fa-circle-plus" style="margin-right: 4px;"></i>Add Sort Level</button>
        <button mat-button color="primary" (click)="removeSortLevel()"><i class="fa-duotone fa-solid fa-circle-minus" style="margin-right: 4px;"></i>Remove Sort Level</button>
    </div>
    <div>
        <button mat-raised-button color="primary" (click)="ok()">OK</button>
        <button mat-raised-button color="secondary" mat-dialog-close>Cancel</button>
    </div>
</mat-dialog-actions>